export const getContracts = async ({
  user,
  dispatchAPI,
  setFilterID,
  setContracts,
  message
}) => {
  const key =
    user.role === 'users:OWNER' ? 'main_informations.owner' : 'pensioners';
  const customer = user.role === 'users:OWNER' ? 'owners' : 'pensioners';

  try {
    const { data: customerData } = await dispatchAPI('GET', {
      url: `${customer}?user=${user._id}`
    });

    // No owner or pensioner record for this account yet: no contract, and no
    // page bug reported as a network error.
    const [profile] = customerData || [];
    if (!profile) {
      setContracts([]);
      return;
    }

    const { data } = await dispatchAPI('GET', {
      url: `supervisions?${key}=${profile._id}&populate=documents._id`
    });

    const updatedContracts = [];

    if (data.length) {
      data.map((supervision) =>
        supervision.documents.map((doc) => {
          if (doc.user === user._id && doc.type.includes('CONTRACT')) {
            updatedContracts.push({
              ...doc,
              supervision_id: supervision._id,
              supervision_reference: supervision.reference,
              document_type: doc.type.includes('OWNER')
                ? 'OWNER_CONTRACT'
                : 'PENSIONER_CONTRACT'
            });
          }
          return null;
        })
      );
    }

    setFilterID(profile._id);
    setContracts(updatedContracts);
  } catch (e) {
    message(e);
  }
};
